import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const SEOServicesPage = lazy(() => import('../pages/seo-services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const RoofingPage = lazy(() => import('../pages/niche/roofing'));
const PlumbingPage = lazy(() => import('../pages/niche/plumbing'));
const TreeServicePage = lazy(() => import('../pages/niche/tree-service'));
const HVACPage = lazy(() => import('../pages/niche/hvac'));
const ElectricianPage = lazy(() => import('../pages/niche/electrician'));
const LandscapingPage = lazy(() => import('../pages/niche/landscaping'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticleCostPage = lazy(() => import('../pages/blog/article-cost/page'));
const ArticleRedesignPage = lazy(() => import('../pages/blog/article-redesign/page'));
const ArticleSEOPage = lazy(() => import('../pages/blog/article-seo/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/seo-services',
    element: <SEOServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/roofing',
    element: <RoofingPage />,
  },
  {
    path: '/plumbing',
    element: <PlumbingPage />,
  },
  {
    path: '/tree-service',
    element: <TreeServicePage />,
  },
  {
    path: '/hvac',
    element: <HVACPage />,
  },
  {
    path: '/electrician',
    element: <ElectricianPage />,
  },
  {
    path: '/landscaping',
    element: <LandscapingPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicyPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/small-business-website-cost-2026',
    element: <ArticleCostPage />,
  },
  {
    path: '/blog/signs-your-website-needs-a-redesign',
    element: <ArticleRedesignPage />,
  },
  {
    path: '/blog/do-you-need-seo-after-website-launch',
    element: <ArticleSEOPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;